document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.show-password, .hide-password').forEach(function (btn) {
        btn.addEventListener('click', function () {
            // Trova l'input password nel parent
            var input = btn.parentElement.querySelector('input');
            if (!input) return;

            if (btn.classList.contains('show-password')) {
                input.type = 'text';
                btn.classList.remove('show-password');
                btn.classList.add('hide-password');
                btn.innerHTML = '<span class="material-symbols-outlined">visibility</span>';
            } else {
                input.type = 'password';
                btn.classList.remove('hide-password');
                btn.classList.add('show-password');
                btn.innerHTML = '<span class="material-symbols-outlined">visibility_off</span>';
            }
        });
    });
});